
import { motion } from "framer-motion";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import InfluencerBrandlyPromote from "../../components/InfluencerBrandlyPromote/InfluencerBrandlyPromote";
import "./InfluencerPage.css";
import RightArrowIcon from "../../assets/InfluencerPageGraphics/rightarrow.png";
import InfluencerLeft1Combined from "../../assets/InfluencerPageGraphics/Left1.png";
import InfluencerLeft2Combined from "../../assets/InfluencerPageGraphics/Left2.png";
import InfluencerRight1Combined from "../../assets/InfluencerPageGraphics/Right1.png";
import InfluencerFAQ from "../../components/InfluencerFAQ/InfluencerFAQ";
import InfluencerHowItWorks from "../../components/InfluencerHowItWorks/InfluencerHowItWorks";

const InfluencerPage = () => {

  return (
    <div className="influencer-page-whole-body">
      <Navbar />

      {/* Hero Section */}
      <section className="influencer-page-hero">
  <div className="influencer-page-hero-wrapper">
    <motion.img
      src={InfluencerLeft1Combined}
      className="influencer-hero-left1-combined"
      alt=""
      initial={{ x: -100, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
    />
    <motion.img
      src={InfluencerLeft2Combined}
      className="influencer-hero-left2-combined"
      alt=""
      initial={{ x: -100, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
    />
    <motion.img
      src={InfluencerRight1Combined}
      className="influencer-hero-right1-combined"
      alt=""
      initial={{ x: 100, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.6, ease: "easeOut" }}
    />

    {/* Main Hero Content */}
    <h1>
      Get <span className="influencer-page-text-blue">Paid</span> To Create
    </h1>
    <p>
      Help professionals and businesses build stronger personal brands—and get rewarded while you do it. Share Brandly with your audience and earn{" "}
      <span className="influencer-page-text-blue">recurring commission</span> every time someone signs up through your link.
    </p>
    <motion.button
      className="influencer-page-join-button"
      whileHover={{
        background: "linear-gradient(90deg, #0B65C3 0%, #5C9ADA 100%)",
        boxShadow: "inset 0 0 0 6px #68AFF8",
        transition: { duration: 0.3, ease: "easeInOut" },
      }}
    >
      <img src={RightArrowIcon} alt="" />
      Join Affiliate Program
    </motion.button>
  </div>
</section>

      {/* How it Works Section */}
      <InfluencerHowItWorks />

      {/* Why promote Brandly */}


      <InfluencerBrandlyPromote />

      {/* Commission Section */}
      <section className="influencer-page-commission">
        <div className="influencer-page-commission-box">
          <h3>25%</h3>
          <p className="influencer-page-subheading">Commission Rate</p>
          <p className="influencer-page-subtext">Recurring earnings for every sale</p>
          <div className="influencer-page-commission-tags">
            <div className="influencer-page-tag">
              <strong>6 months</strong>
              <span>Cookie Duration</span>
            </div>
            <div className="influencer-page-tag">
              <strong>$50</strong>
              <span>Min Payout</span>
            </div>
            <div className="influencer-page-tag">
              <strong>PayPal / Wire Transfer</strong>
              <span>Payments</span>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <InfluencerFAQ />

      {/* Final CTA */}
      <section className="influencer-page-cta">
        <h2 className="influencer-page-cta-heading">Ready to Start Earning?</h2>
        <p className="influencer-page-cta-subtext">
          Signing up is quick and free. Share, track, and earn—simple as that.
        </p>
        <button className="influencer-page-cta-button">Join Affiliate Program</button>
        <p className="influencer-page-cta-terms">
          By joining, you agree to our <a href="/">Affiliate Terms & Conditions</a>.
        </p>
      </section>

      <Footer />
    </div>
  );
};

export default InfluencerPage;
